import { render, staticRenderFns } from "./LivingDonorDocuments.vue?vue&type=template&id=5119f336"
import script from "./LivingDonorDocuments.vue?vue&type=script&lang=ts"
export * from "./LivingDonorDocuments.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/components/prototypes/_locales/RecipientDocuments.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2Fprototypes%2Fliving_donor%2Forgans%2FLivingDonorDocuments.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports